import Api from "@/api/index";
import store from "@/store";
import alerts from "@/components/alerts/alert";
// import router from "@/router";
import confirmations from "./confirmations";
import { uuid } from "vue-uuid";
import router from "@/router";
import AuthenticationService from "@/services/AuthenticationService";

const staff = {
  namespaced: true,
  state: {
    all: [],
    datas: {},
    queryParam: {},
    modalCreate: false,
    modalEdit: false,
    detail: null,
    modalDetail: false,
    modalTeacherSubject: false,
    paramsSubjectTeacher: null,
    loading: false,
    activationData: null,
    activationModal: false,
    register: {
      // name: "staff",
      // gender: "Laki-Laki",
      // birth_place: "3171",
      // birth_date: "2000-05-15",
      // phone_number: "08121212121",
      // email: "operator@mail.com",
      // address: "jl. operator",
      // rt: "01",
      // rw: "02",
      // kode_pos: "11111",
    },
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_ACTIVATION_DATA(state, data) {
      state.activationData = data;
    },
    SET_ACTIVATION_MODAL(state, data) {
      state.activationModal = data;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_MODAL_CREATE(state, data) {
      state.modalCreate = data;
    },
    SET_DETAIL(state, data) {
      state.detail = data;
    },
    SET_MODAL_DETAIL(state, data) {
      state.modalDetail = data;
    },
    SET_MODAL_EDIT(state, data) {
      state.modalEdit = data;
    },
  },
  actions: {
    closeModalCreate({ commit }) {
      commit("SET_MODAL_CREATE", false);
    },
    closeModalDetail({ commit }) {
      commit("SET_MODAL_DETAIL", false);
    },
    getSubject({ state }, subjects) {
      state.modalTeacherSubject = true;
      state.paramsSubjectTeacher = subjects;
      // const subject_ids = subjects.map((subject) => subject.pivot.subject_id);
      // console.log(JSON.stringify(subject_ids));

      // router.push({
      //   name: "BackofficeSubjectPage",
      //   query: { subject_id: JSON.stringify(subject_ids) },
      // });
    },
    subjectIds(subjects) {
      // Mengambil hanya subject_id dari setiap item
      return subjects.map((subject) => subject.pivot.subject_id);
    },
    onRefresh({ state }) {
      store.dispatch("staff/paginate", state.queryParam);
    },
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("staff/page", payload).then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
    onAction({ commit, state }, payload) {
      if (payload[1] === "Create") {
        commit("SET_MODAL_CREATE", true);
        state.register = {};
      } else if (payload[1] === "Detail") {
        // console.log(JSON.stringify(payload[0]));
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      } else if (payload[1] === "Edit") {
        state.register = payload[0];
        store.dispatch("regions/getRegency", payload[0]["province_id"]);
        store.dispatch("regions/getDistrict", payload[0]["regency_id"]);
        store.dispatch("regions/getVillage", payload[0]["district_id"]);
        commit("SET_MODAL_EDIT", true);
      }
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(payload[0], `staff/${payload[1]}`);
    },
    activation({ commit }, payload) {
      commit("SET_ACTIVATION_MODAL", true);
      commit("SET_ACTIVATION_DATA", payload);
    },
    async prosesActivation({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.put(
        `staff/${payload.items.staff_id}/activation`,
        payload
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          commit("SET_ACTIVATION_MODAL", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("staff/onRefresh");
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      // const params = {
      //   questions: payload.details,
      //   json_detail: JSON.stringify(payload),
      // };
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.postFormData("staff", state.register)
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("staff/onRefresh");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },

    async update({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.postFormData(
        "staff/update/" + payload.staff_id,
        state.register
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_EDIT", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("staff/onRefresh");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
  },
};

export default staff;
